import { ApiReducer, HTTP_STATUS, makeApiAction, makeApiReducer, RsaaTypes } from '../../core/redux/api/reduxStandardApiAction';
import { apiGetPaymentMethod } from '../../core/redux/api/endpoints';
import { IAppState } from '../../core/redux/IAppState';
import { ACTION_TYPE } from '../../core/redux/actionType';
import { addError, addLoading, getLoading, removeLoadingAndError } from '../../core/redux/api/module';
import { hasTrippedBreaker, updateBreaker } from '../../core/redux/api/circuitBreaker/module';
import { GuestPaymentRegistration } from './paymentRegistration';
import { PaymentMethod } from './paymentMethod';
import { assoc } from 'ramda';
import { GuestDetails } from '../guestDetails';
import { updateGuest } from '../module';
import * as R from 'ramda';


const KEY_ACTION = ACTION_TYPE.GET_PAYMENT_METHOD_REQUEST;
const ACTIONS    = [
  ACTION_TYPE.GET_PAYMENT_METHOD_REQUEST,
  ACTION_TYPE.GET_PAYMENT_METHOD_RESPONSE,
  ACTION_TYPE.GET_PAYMENT_METHOD_ERROR,
];


/**
 * Constructs a Redux Action for getting payment method details and its associated payment registrations
 * @param registration - the registration for which the payment method details will be retrieved
 */
export const getPaymentMethodAction = (registration: GuestPaymentRegistration, guestId: string) => makeApiAction(
  {
    method:   'GET',
    endpoint: apiGetPaymentMethod(registration.paymentMethodId),
    headers:  (state: IAppState) => ({
      'content-type':  'application/json',
      'Authorization': `Bearer ${state.auth.bearerToken}`,
    }),
    types:    ACTIONS.map(action => ({ type: action, meta: { registration, guestId } })) as RsaaTypes,
    bailout:  state => !!getLoading(state, registration.paymentMethodId.toString(), KEY_ACTION) || hasTrippedBreaker(state, KEY_ACTION),
  },
);


const reducer: ApiReducer<PaymentMethod> = (state, action, error, isLoading, payload) => {
  const registration = action.meta.registration;
  const guestId = action.meta.guestId;
  const paymentMethodId   = registration.paymentMethodId;

  if (isLoading) {
    return addLoading(state, paymentMethodId, KEY_ACTION);
  }

  const withBreaker = updateBreaker(state, KEY_ACTION, !!error);

  // Handle 404 - not found - this is expected if the guest has no payment registrations  
  if (error && action.payload.status !== HTTP_STATUS.NOT_FOUND) {
    return addError(withBreaker, paymentMethodId, KEY_ACTION, error);
  }

  const noLoadingOrError = removeLoadingAndError(withBreaker, paymentMethodId, KEY_ACTION);

  return updateGuest(noLoadingOrError, guestId, R.assocPath([ 'paymentMethod' ], payload));

  //return assoc('paymentMethod', payload, noLoadingOrError);
};


export const getPaymentMethodReducer = makeApiReducer<PaymentMethod>(ACTIONS, KEY_ACTION, reducer);
